// Manual Test Functions for Browser Console

import { authService, dmsService } from './index';

// Add to window for easy console access
declare global {
  interface Window {
    testTurfAI: {
      checkConfig: () => void;
      testAuth: () => Promise<void>;
      testDMS: () => Promise<void>;
      testBasicFetch: () => Promise<void>;
    };
  }
}

// Simple configuration check
function checkConfig() {
  console.log('🔧 TurfAI Configuration Check:');
  console.log('Base URL:', import.meta.env.VITE_TURFAI_DMS_URL);
  console.log('API URL:', import.meta.env.VITE_TURFAI_API_URL);
  console.log('Test Email:', import.meta.env.VITE_TURFAI_TEST_EMAIL);
}

// Test authentication
async function testAuth() {
  try {
    console.log('🔐 Testing Authentication...');
    const result = await authService.loginWithTestCredentials();
    console.log('✅ Auth Success:', result);
  } catch (error) {
    console.error('❌ Auth Failed:', error);
  }
}

// Test DMS after auth
async function testDMS() {
  try {
    console.log('📊 Testing DMS...');
    const result = await dmsService.checkConnection();
    console.log('DMS Connection Result:', result);
  } catch (error) {
    console.error('❌ DMS Failed:', error);
  }
}

// Basic fetch test to check if the URL is reachable
async function testBasicFetch() {
  try {
    console.log('🌐 Testing basic fetch to TurfAI...');
    const baseUrl = import.meta.env.VITE_TURFAI_DMS_URL;
    console.log(`Fetching: ${baseUrl}`);
    
    const response = await fetch(baseUrl, {
      method: 'GET',
      mode: 'cors'
    });
    
    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));
    
    if (response.ok) {
      const text = await response.text();
      console.log('Response body (first 200 chars):', text.slice(0, 200));
    }
  } catch (error) {
    console.error('❌ Basic fetch failed:', error);
  }
}

// Export for window
export const manualTest = {
  checkConfig,
  testAuth,
  testDMS,
  testBasicFetch
};

// Make available on window for console access
if (typeof window !== 'undefined') {
  window.testTurfAI = manualTest;
}